export default "__VITE_ASSET__Ckync9CJ__"